import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import SidesScreen from './sides';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import FavoritesScreen from './favorites';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showSides, setShowSides] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
   
     const [datasish, setdatasish] = useState(false);
    const [valentine, setvalentine] = useState([]);
      const [appetizers, setAppetizers] = useState(false);
    
    const [showFavorites, setshowFavorites] = useState(false);
   const [breakfast, setbreakfast] = useState(false);
    


     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    

    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                
                if (item.id === 373) {
                    setAppetizers(item);
                }
               if (item.id === 422) {
                setbreakfast(item);
              }
               
            });
      }, [menus]);
    
    
    useEffect(() => {
    if (valentine) {
      valentine.map((item) => {
        if (item.id === 4541) {
          setdatasish(item);
        }
      });
    }
  }, [valentine]);
    
    

     useEffect(() => {
            
              setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowSides(false)
         setShowDetailProduct(false)
         setshowFavorites(false)
     }, [goHomeInit]);
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowSides(false)
            setShowDetailProduct(false)
          setshowFavorites(false)
          getInitData();

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    

  return (
      <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showHome={false} showBack={false} showImageTop={true} setShowSpecials={() => {
           setShowSpecials(true)
        }} goCategories={setshowCategories}>
            <div>
                <div style={{ width: '100%' }}>
                    <img  onClick={() => {
                                setdishs(breakfast)
                               setShowListProduct(true)
                            }}
                        style={{
                            width: 330,
                            height: 170,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -50,
                          marginBottom: -20,
                          position: 'relative',
                            zIndex: 999
                            
                        }}
                        src={require('./assets/logo.png')}
                    />
                </div>

                 <div
             onClick={() => {
                                setdishs(appetizers)
                               setShowListProduct(true)
                            }}
                    style={{
                marginBottom: 20,
              backgroundColor: '#EBB234',
              width: '92%',
              paddingBlock: 10,
              paddingInline: 5,
              borderRadius: 10,
                marginTop: 23,
                display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
                        alignItems: 'center',
              margin: '20px auto'
            }}>
            <img
              style={{
                width: 40,
                height: 40,
                objectFit: 'contain',
                marginLeft: 10,
              }}
              src={require('./assets/left22.png')}
            />
            <p
              style={{
                fontWeight: '700',
                color: '#4F1C85',
                fontSize: 29,
                textAlign: 'center',
              }}>
              {langEng
                ? 'CHECK OUT OUR APPETIZERS'
                : 'PRUEBA NUESTROS APPETIZZERS'}
            </p>
            <img
              style={{
                width: 40,
                height: 40,
                objectFit: 'contain',
                marginLeft: 10,
              }}
              src={require('./assets/left22.png')}
            />
                </div>
                
                <div style={{ display: 'flex', width: '100%',position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box' }}>
                       
                    <div style={{ width: '40%'}}>
                        <video
                             onClick={() => {
                                setshowFavorites(true)
                            }}
                            src={require('./assets/banner.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                width: '100%',
                                height: 580,
                                objectFit: 'cover',
                                borderRadius: 14,
                                marginTop: 9
                               
                            }}
                        />

                    </div>
                    <div style={{ width: '60%',borderRadius: 10, boxSizing: 'border-box'}}>

                       <div
                           
                            style={{width: '100%', marginTop: 10}}>
                            <img
                                
                                style={{
                                width: '100%',
                                height: 250,
                                borderRadius: 14,
                                objectFit: 'contain',
                                }}
                                src={require('./assets/hot.png')}
                            />
                            <img
                                onClick={()=> setshowCategories(true)}
                                style={{
                                    marginTop: 50,
                                width: '100%',
                                height: 270,
                                borderRadius: 14,
                                objectFit: 'contain',
                                }}
                                src={require('./assets/see.png')}
                            />
                        </div>
                        
                        {/* <img
                            onClick={() => {
                                setDataDish({ dish: dataDrink, alldish: drinks.menus})
                                setShowDetailProduct(true)
                            }}
                            style={{
                                      marginTop: 7,
                                    width: '100%',
                                    height: 245,
                                    objectFit: 'contain',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/banner3.png')}
                            /> */}
                    </div>
                </div>
               
            </div>


            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            {showSides && <SidesScreen setShowHappy={setShowSides} />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            {showBar && <BarScreen setShowBar={setShowBar} />}
                
            {showFavorites && <FavoritesScreen setshowCategories={setshowFavorites} />}


            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
            
      </LayoutContent>
      </div>
    );
}

export default Index;